import { render, staticRenderFns } from "./CompanySettingsLoyaltyRewards.vue?vue&type=template&id=3c3828a0&scoped=true"
import script from "./CompanySettingsLoyaltyRewards.vue?vue&type=script&lang=js"
export * from "./CompanySettingsLoyaltyRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3828a0",
  null
  
)

export default component.exports